/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react'

import SurveyFilter from '../../../components/SurveyFilter'
import ManageCommentDrawer from './ManageCommentDrawer'

import MaterialTable from 'material-table'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import { useStyles } from './styles'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { SURVEYS, ALL_COMMENTS, TOGGLE_COMMENT, COMMENTS_PER_SERCTORS, COMMENTS_META } from './queries'
import { CircularProgress, Grid, Button, Checkbox } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import { toast } from 'react-toastify'
import zipcelx from 'zipcelx'


window.MaterialTable = MaterialTable;
function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={ value !== index }
      id={ `simple-tabpanel-${index}` }
      aria-labelledby={ `simple-tab-${index}` }
      { ...other }
    >
      { value === index && (
        <Box p={ 2 } style={{ minHeight: 550 }}>
          <Paper elevation={ 1 }>
            <Box p={ 3 }>
              { children }
            </Box>
          </Paper>
        </Box>
      ) }
    </Typography>
  )
}

export default function(_props) {
  const classes = useStyles()
  const table = useRef()


  const [reload, setReload] = useState(false);
  const [filterSector, setFilterSector] = useState(0)
  const [filterSubtopic, setFilterSubtopic] = useState(0)
  const [filterSubtopics, setFilterSubtopics] = useState([])
  const [filterTopic, setFilterTopic] = useState(0)
  const [filterDimension, setFilterDimension] = useState(null)
  const [filterVisualizationType, setFilterVisualizationType] = useState('newModel')
  const [filterHasReference, setFilterHasReference] = useState(false)
  const [currentSelectedQuestionId, setCurrentSelectedQuestionId] = useState()
  const [currentSelectedQuestionData, setCurrentSelectedQuestionData] = useState()
  const [currentSearch, setCurrentSearch] = useState({})

  const [toggleComment] = useMutation(TOGGLE_COMMENT, {
    onCompleted: (_) => {
      toast.success('Comentário atualizado com sucesso')
    }
  })
  const { data: surveys, loading: surveysLoading, error: surveysError } = useQuery(SURVEYS)
  let data, loading, error;

  const [survey, setSurvey] = React.useState(0)

  if (error || surveysError) return error.message

  if (!survey && !surveysLoading && surveys.allSurveys.length > 0) {
    const officialSurvey = (
      surveys.allSurveys.find(s => s.official) ||
      surveys.allSurveys[0]
    )
    setSurvey(officialSurvey)
  }

  const {
    data: commentsPerSector,
    loading: commentsLoading,
    error: commentsError
  } = useQuery(COMMENTS_PER_SERCTORS, {
    variables: { surveyId: survey.id, limit: 10  }
  })

  const {
    data: commentsMeta,
    loading: commentsMetaLoading,
    error: commentsMetaError
  } = useQuery(COMMENTS_META, {
    variables: { surveyId: survey.id  }
  })

  const excelHeaders = [
    'Usuário',
    'Status',
    'Privado',
    'Dimensão ISE',
    'Dimensão',
    'Tema',
    'ID da pergunta',
    'Nº da pergunta',
    'Pergunta',
    'Indicador',
    'Comentário',
  ].map((s) => ({ value: s, type: 'string' }))

  const columns = [
    { title: 'Usuário', field: 'userName'},
    { title: 'Data', field: 'createdAt' },
    { title: 'Privado', field: 'restrict' },
    { title: 'Status', field: 'statusName' },
    { title: 'Comentário', field: 'content' },
    { title: 'Id da pergunta', field: 'questionId'},
    { title: 'Nº da pergunta', field: 'hierarchy'},
    { title: 'Dimensão ISE', field: 'dimension' },
    { title: 'Indicador', field: 'indicator',  },
    { title: 'Dimensão', field: 'topic' },
  ]


  let questions = [],
    restrict = [],
    tags = [],
    topics = [],
    subtopics = [],
    indicators = [],
    comments = [],
    filteredComments = [],
    dimensions = [],
    newWorkbook = null

  if (!commentsMetaLoading && !surveysLoading) {
    // comments   = allComments.filter(c => c.question.survey.id === survey.id)
    questions  = commentsMeta.allCommentsMeta.questions.map((e) => { e.name });
    restrict   = commentsMeta.allCommentsMeta.restrict.map((e) => { e.name });
    tags       = commentsMeta.allCommentsMeta.tags.map((e) => { e.name });
    topics     = commentsMeta.allCommentsMeta.topics.map((e) => { e.name });
    subtopics  = commentsMeta.allCommentsMeta.subtopics.map((e) => { e.name });
    indicators = commentsMeta.allCommentsMeta.indicators.map((e) => { e.name });
    dimensions = commentsMeta.allCommentsMeta.dimensions.map((e) => { e.name });
  }

  const filterComments = (comments, dimension, topic, subtopic, sector) => {
    const filterApplied = comments
      .filter(comment => {
        const tagsHash = comment
          .question
          .tags
          .reduce((hash, tag) => { hash[tag.id] = tag.name; return hash }, {})

        let choices = comment.question.choices.map(
          choice => choice.tags.filter(tag => tag.type === 'subtopic')
        )
        let commentChoices = [...new Set(...choices)]
        let commentHasSectorFilter = filterSubtopics.find(tag => commentChoices.find(choice => choice.id === tag.id))

        let commentHasDimension = !!dimension ? tagsHash[dimension] : true
        let commentHasTopic     = !!topic ? tagsHash[topic] : true
        let commentHasSubtopic  = !!subtopic ? tagsHash[subtopic] : true
        let commentHasSector    = !!sector ? commentHasSectorFilter : true

        return commentHasSector && !!commentHasDimension && commentHasTopic && commentHasSubtopic
      })

    return filterApplied
  }

  const generate = async () => {
    const { data, loading, error } = await window._CLIENT.query({
      query: ALL_COMMENTS,
      variables: {
        pageSize: 1000000000,
      }
    })
    const comments   = data.allComments.filter(c => c.question.survey.id === survey.id)

    const excelContent = [
      comments.map(comment => {
        const question   = comment.question
        const questionId = question.id
        const user       = comment.userName
        const restrict   = comment.restrict === true ? 'Sim' : 'Não'
        const status     = comment.status === 'approved' ? 'Aprovado' : 'Não aprovado'
        const tags       = question.tags
        const topics     = [...new Set(tags.filter(tag => tag.type === 'topic').map(tag => tag.name))]
        const subtopics  = [...new Set(tags.filter(tag => tag.type === 'subtopic').map(tag => tag.name))]
        const indicators = [...new Set(tags.filter(tag => tag.type === 'indicator').map(tag => tag.name))]
        const dimensions = [...new Set(tags.filter(tag => tag.type === 'dimension').map(tag => tag.name))]

        return [
          { value: user, type: 'string' },
          { value: status, type: 'string' },
          { value: restrict, type: 'string' },
          { value: dimensions, type: 'string' },
          { value: topics, type: 'string' },
          { value: subtopics, type: 'string' },
          { value: questionId, type: 'number' },
          { value: comment.question.hierarchy, type: 'number' },
          { value: comment.question.statement, type: 'string' },
          { value: indicators, type: 'string' },
          { value: comment.content, type: 'string' },
        ]
      })
    ]

    const config = {
      filename: `comments_${ +new Date() }`,
      sheet: {
        data: [excelHeaders, ...excelContent[0]]
      }
    }
    zipcelx(config)
  }

  const handleOpenCommentDrawer = (question) => {
    setCurrentSelectedQuestionId(question.questionId)
    setCurrentSelectedQuestionData(question)
  }

  const handleCloseCommentDrawer = () => {
    setCurrentSelectedQuestionId(false)
  }
  useEffect(()=>{
    console.log(table);
  })

  const handleSelection = ()=>{

  }

  return (
    <>
      <ManageCommentDrawer
        closeDialog={ handleCloseCommentDrawer }
        questionId={ currentSelectedQuestionId }
        questionData={ currentSelectedQuestionData }
      />
      <AppBar position="static">
        <Tabs
          value={ 0 }
          aria-label="Gerenciar comentários"
        >
          <Tab label="Comentários" />
        </Tabs>
      </AppBar>
      <TabPanel value={ 0 } index={ 0 }>
        <div>
          <Grid className={ classes.header } container item xs={ 12 }>
            <Typography variant="h5">
              Comentários do questionário oficial ({ survey.name })
            </Typography>

            <Grid container item xs={ 12 } md={ 1 }>
              <div
                style={{ width: '100%' }}
              >
                <Button fullWidth onClick={ () => generate() } disabled={ loading || surveysLoading }>
                  {
                    loading || surveysLoading
                      ? <CircularProgress size={ 25 } />
                      : 'Exportar'
                  }
                </Button>
              </div>
            </Grid>
          </Grid>
          {
            (loading || surveysLoading) && (
              <Grid container justify="center">
                <Grid item xs={ 1 }>
                  <Box mt={ 5 }>
                    <CircularProgress />
                  </Box>
                </Grid>
              </Grid>
            )
          }

          <SurveyFilter
            surveyId={ survey }
            userProfile='administrator'
            sector={ filterSector }
            setSector={ (e)=>{
              console.log(e)

              setFilterSector(e);
              setReload(true);

              setTimeout(()=>{
                setReload(false);
              }, 200);
            }  }
            subtopic={ filterSubtopic }
            setSubtopic={ (e)=>{
              console.log(e)

              setFilterSubtopic(e);
              setReload(true);

              setTimeout(()=>{
                setReload(false);
              }, 200);
            }  }
            subtopics={ commentsMeta ? commentsMeta.allCommentsMeta.subtopics : [] }
            setSubtopics={ setFilterSubtopics }
            topic={ filterTopic }
            topics={ topics }
            setTopic={ setFilterTopic }
            dimension={ filterDimension }
            setDimension={ setFilterDimension }
            visualizationType={ filterVisualizationType }
            setVisualizationType={ setFilterVisualizationType }
            hasReference={ filterHasReference }
            setHasReference={ setFilterHasReference }
            filteredComments={ filteredComments }
          >


          </SurveyFilter>
          {reload ? 'true': 'false'}


          {!reload &&(
          <MaterialTable
            title="Comentários"
            columns={ columns }
            filterSector={filterSubtopic}
            pageSize={20}
            data={(query) =>{
              console.log({ a:this, query, filterSubtopic})
              return new Promise(async (resolve, reject) => {
                const { pageSize, page } = query;
                let variables = {

                  // where: {
                  //   question:{
                  //     tags:{
                  //       sectorId: filterSector,
                  //     }
                  //   }
                  //
                  // },
                  pageSize,
                  page,
                };
                if(filterSubtopic){
                  variables['tag'] = filterSubtopic;
                }
                const { data, loading, error } = await window._CLIENT.query({
                  query: ALL_COMMENTS,
                  variables
                })


                  // prepare your data and then call resolve like this:
              resolve({
                  data: data.allComments.map((comment)=>{
                    const question              = comment.question
                    const tags                  = question.tags
                    const topics                = [...new Set(tags.filter(tag => tag.type === 'topic').map(tag => tag.name))]
                    const subtopics             = [...new Set(tags.filter(tag => tag.type === 'subtopic').map(tag => tag.name))]
                    const indicators            = [...new Set(tags.filter(tag => tag.type === 'indicator').map(tag => tag.name))]
                    const dimension             = [...new Set(tags.filter(tag => tag.type === 'dimension').map(tag => tag.name))]
                    const dimensionAbbreviation = tags.filter(tag => tag.type === 'dimension').map(tag => tag.abbreviation)
                    const questionId            = question.id
                    const statement             = question.statement
                    const commentId             = comment.id

                    return {
                      commentId: commentId,
                      hierarchy: comment.question.hierarchy,
                      restrict: comment.restrict === true ? 'Sim' : 'Não',
                      userName: comment.userName,
                      status: comment.status,
                      statusName: comment.status === 'approved' ? 'Aprovado' : 'Não aprovado',
                      createdAt: comment.createdAt,
                      content: comment.content && comment.content.length >= 100 ? `${ comment.content.substring(0, 97) }...` : comment.content ,
                      contentDrawer: comment.content,
                      indicator: indicators,
                      topic: topics.join(', '),
                      subtopic: subtopics.join(', '),
                      subtopicsLimit: subtopics.join(', '),
                      dimension: dimension,
                      questionId: questionId,
                      drawerContent: {
                        dimensionAbbreviation: dimensionAbbreviation,
                        statement: statement
                      }
                    }
                  }), // your data array
                  page, // current page number
                  totalCount: data.allCommentsCount // total row number
                });
              }) }}
            style={{ boxShadow: 'none', width: '100%' }}
            onRowClick={ (_event, row) => handleOpenCommentDrawer(row) }
            options={{
              toolbar: {
                searchPlaceholder: 'Pesquisar',
              },
              pageSize: 20,
              pageSizeOptions: [ 20,50,100,250 ],
              padding: 'dense',

              tableLayout: 'fixed',
            }}
            localization={{
              pagination: {
                labelRowsSelect: 'Comentários'
              },
              body: {
                emptyDataSourceMessage: 'Não existem comentários'
              }
            }}
            actions={ [
              rowData => ({
                icon: () => (
                  <Checkbox
                    checked={ rowData.status === 'approved' }
                    size='small'
                  >
                    <MenuIcon />
                  </Checkbox>
                ),
                tooltip: 'Aprovar',
                onClick: (_e, row ) => toggleComment({
                  variables: { commentId: row.commentId }
                })
              })
            ] }
          />
          )}
        </div>
      </TabPanel>
    </>
  )
}
